import * as React from 'react';
import { memo } from 'react';

const SvgArrowUpRightV2 = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m4.5 13.5 9-9M6.188 4.5H13.5v7.313", stroke: "currentColor", strokeWidth: 1.125, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgArrowUpRightV2);

export { Memo as default };
